<div class="pdf-container">
  <<iframe class="ifram" [src]="getPdf(src)"></iframe>
</div>
